
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5db83946&scoped=true!stylus-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./multipleColumn.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./multipleColumn.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5db83946!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./multipleColumn.vue"),
  /* scopeId */
  "data-v-5db83946",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/multipleColumn/multipleColumn.vue
// module id = 204
// module chunks = 2